<template>
  <div id="app">
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div
      class="image"
      v-for="(image, imageIndex) in images"
      :key="imageIndex"
      @click="index = imageIndex"
      :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
    ></div>
  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  name: 'App',

  data () {
    return {
      images: [
        'https://istoryline.github.io/hand-drawn_storylines/AttackonTitan.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/BattlethroughtheHeaven.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/Bunshin.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/ChasingtheDragon.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/COCO.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/DetectiveConan.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/Frozen.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/GreenSnake.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/HarryPotterI.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/HelloOldTime.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/Inception.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/ISLAND.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/Jackie.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/JaneEyre.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/JusticeLeague(2).jpg',
        'https://istoryline.github.io/hand-drawn_storylines/JusticeLeague.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/Minions.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/MonkeyKingHeroisBack.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/MonsterHunt.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/Narnia.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/Naruto.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/PeoplefromtheMoon.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/PrideandPrejudice.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/SourceCode.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/StormRider-ClashofEvils.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/SwordArtOnline.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/TheHobbitIII.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/TheMatrix.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/TheMerchantofVenice.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/TheMoonandSixpence.png',
        'https://istoryline.github.io/hand-drawn_storylines/TheThreeKingdomsEra.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/TraintoBusan.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/WorldAmazingWords.jpg',
        'https://istoryline.github.io/hand-drawn_storylines/Wukong.jpg'
      ],
      index: null
    }
  },

  components: {
    'gallery': VueGallery
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.image {
  float: left;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue